import { render, staticRenderFns } from "./MarketIndex.vue?vue&type=template&id=54b37b07&scoped=true"
import script from "./MarketIndex.vue?vue&type=script&lang=js"
export * from "./MarketIndex.vue?vue&type=script&lang=js"
import style0 from "./MarketIndex.vue?vue&type=style&index=0&id=54b37b07&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b37b07",
  null
  
)

export default component.exports